// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"769":"64140342","2299":"64140342","2587":"c2a333c1","3550":"5590196c","5617":"d4b4c205","6297":"c2a333c1","6493":"64140342","7761":"64140342","7866":"c2a333c1","9727":"64140342"}[chunkId] + ".chunk.css";
};